import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const shortRef = (o) => `#${((o.id || o.session_id || "").slice(-6) || "------").toUpperCase()}`;

export default function OrdersList() {
  const [orders, setOrders] = useState([]);
  const [openId, setOpenId] = useState(null);
  useEffect(() => { api.get("/admin/orders").then((r) => setOrders(r.data)); }, []);
  return (
    <div>
      <h1 className="font-display text-2xl sm:text-3xl text-gold mb-6">Orders</h1>

      {orders.length === 0 && (
        <div className="curio-card p-8 text-center text-parchment/60 italic">No orders yet.</div>
      )}

      {/* Mobile: stacked cards */}
      <div className="grid grid-cols-1 sm:hidden gap-3">
        {orders.map((o) => {
          const open = openId === o.id;
          return (
            <div key={o.id} className="curio-card p-4" data-testid={`admin-order-card-${o.id}`}>
              <div className="flex justify-between items-start gap-3">
                <div>
                  <div className="font-caption text-[10px] text-brass tracking-wider">ORDER</div>
                  <div className="text-gold font-display text-xl" data-testid={`order-ref-${o.id}`}>Order {shortRef(o)}</div>
                </div>
                <div className="text-gold font-serif text-lg whitespace-nowrap">${(o.amount || 0).toFixed(2)}</div>
              </div>
              <div className="mt-2 text-[11px] text-parchment/70">{new Date(o.created_at).toLocaleString()}</div>
              <div className="mt-2 text-sm text-cream">{(o.items || []).map((i) => `${i.title} × ${i.quantity}`).join(", ")}</div>
              <div className="mt-2 flex justify-between items-center">
                <span className={`font-caption text-[10px] tracking-wider ${o.payment_status === "paid" ? "text-gold" : "text-brass"}`}>
                  {(o.payment_status || "pending").toUpperCase()}
                </span>
                <button onClick={() => setOpenId(open ? null : o.id)} className="font-caption text-[10px] text-parchment/70 underline"
                        data-testid={`order-details-toggle-${o.id}`}>
                  {open ? "Hide details" : "View details"}
                </button>
              </div>
              {open && (
                <div className="mt-3 pt-3 border-t border-brass-soft space-y-1 text-[11px]">
                  <div><span className="text-brass">Fulfillment: </span><span className="text-parchment/80">{(o.status || "").toUpperCase() || "—"}</span></div>
                  <div><span className="text-brass">Session ID: </span><span className="text-parchment/60 break-all">{o.session_id}</span></div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Tablet/Desktop: table */}
      <div className="hidden sm:block curio-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-brass font-caption text-[10px]">
            <tr className="border-b border-brass-soft">
              <th className="text-left p-3">Order</th><th className="text-left p-3">Date</th><th className="text-left p-3">Items</th>
              <th className="text-left p-3">Total</th><th className="text-left p-3">Payment</th><th className="text-left p-3">Fulfillment</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-brass-soft/40" data-testid={`admin-order-row-${o.id}`}>
                <td className="p-3">
                  <div className="text-gold font-display text-base" data-testid={`order-ref-${o.id}`}>Order {shortRef(o)}</div>
                  <div className="text-parchment/40 text-[10px] font-mono" title={o.session_id}>{o.session_id?.slice(0, 12)}…</div>
                </td>
                <td className="p-3 text-parchment/70">{new Date(o.created_at).toLocaleDateString()}</td>
                <td className="p-3 text-parchment/80">{(o.items || []).map((i) => `${i.title} × ${i.quantity}`).join(", ")}</td>
                <td className="p-3 text-gold">${(o.amount || 0).toFixed(2)}</td>
                <td className="p-3">
                  <span className={`font-caption text-[10px] tracking-wider ${o.payment_status === "paid" ? "text-gold" : "text-brass"}`}>
                    {(o.payment_status || "pending").toUpperCase()}
                  </span>
                </td>
                <td className="p-3 text-parchment/70 text-xs">{(o.status || "").toUpperCase() || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
